var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _path14, _path15, _g3, _path16, _path17, _g4, _path18, _path19, _g5, _path20, _path21, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner7Mo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 90,
    viewBox: "0 0 271 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 90,
    fill: "#3937A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8235 57.653V36.0063H71.7279V57.653H67.8235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7731 36.0368V57.6834L95.8688 54.7147L81.8139 43.9846V57.6834H77.9095V36.0986L81.8139 39.0673L95.8688 49.7984V36.0063L99.7731 36.0368Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.601 42.0056V41.8819C119.601 40.8 118.696 39.9029 117.602 39.9029H108.732C107.639 39.9029 106.733 40.8 106.733 41.8819V42.0056C106.733 43.0876 107.639 43.9846 108.732 43.9846H116.602C118.633 43.9846 120.444 44.8503 121.694 46.2113C121.787 46.3036 121.85 46.3962 121.943 46.4894C122.912 47.6646 123.505 49.18 123.505 50.8182C123.505 54.5917 120.413 57.6527 116.603 57.6527H109.763C105.952 57.6527 102.861 54.5917 102.861 50.8182H106.765C106.765 52.4573 108.108 53.7869 109.763 53.7869H116.603C118.258 53.7869 119.633 52.4573 119.633 50.8182C119.633 49.1791 118.258 47.8495 116.603 47.8495H108.732C107.139 47.8495 105.703 47.2314 104.641 46.2113C104.359 45.9323 104.11 45.6237 103.891 45.2838C103.236 44.3553 102.861 43.2112 102.861 41.9742V41.8505C102.861 38.6351 105.484 36.0063 108.732 36.0063H117.602C120.851 36.0063 123.506 38.6351 123.506 41.8505V41.9742L119.601 42.0056H119.601Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.235 46.8297C146.235 50.6641 149.389 53.7872 153.262 53.7872H160.29V49.6439H153.262V45.7782H164.194V57.653H153.262C147.235 57.653 142.331 52.7975 142.331 46.8297C142.331 40.8618 147.235 36.0063 153.262 36.0063H164.194V39.8712H153.262C149.389 39.8712 146.235 42.995 146.235 46.8297Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.113 36.0063V57.653H185.208V47.7267H171.153V57.653H167.249V36.0063H171.153V43.861H185.208V36.0063H189.113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214 36.0366V39.9024H205.037V57.6833H201.132V39.9024H192.168V36.0366H214Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0096 51.0923H57.1984V53.7942H62.6651V54.9703H57.1981V57.6722H56.0096V51.0923Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9999 43.5483H62.6553V44.7245H59.6037V48.9609H62.6553V50.1371H55.9999V48.9609H58.4152V44.7245H55.9999V43.5483Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7969 41.426H58.415V37.1895H59.6032V41.426H60.8579C61.1908 41.426 61.4663 41.1532 61.4663 40.8236V36.0137H62.6545V40.8236C62.6545 41.8026 61.8464 42.5936 60.8576 42.5936H57.7969C56.8081 42.5936 55.9997 41.8029 55.9997 40.8236V36.0137H57.1885V40.8236C57.1885 41.1532 57.464 41.426 57.7969 41.426Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.785 28.7778C130.412 28.7778 129.3 29.8796 129.3 31.239C129.3 32.5984 131.785 35.5772 131.785 35.5772C131.785 35.5772 134.271 32.5981 134.271 31.239C134.271 29.8799 133.158 28.7778 131.785 28.7778ZM131.801 32.0039C131.405 32.0127 131.076 31.7017 131.068 31.3093C131.059 30.9166 131.373 30.5914 131.769 30.5827C132.166 30.5739 132.494 30.8849 132.503 31.2773C132.512 31.67 132.198 31.9951 131.801 32.0036V32.0039Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 28,
    width: 6,
    height: 8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.785 28.7778C130.412 28.7778 129.3 29.8796 129.3 31.239C129.3 32.5984 131.785 35.5772 131.785 35.5772C131.785 35.5772 134.271 32.5981 134.271 31.239C134.271 29.8799 133.158 28.7778 131.785 28.7778ZM131.801 32.0039C131.405 32.0127 131.076 31.7017 131.068 31.3093C131.059 30.9166 131.373 30.5914 131.769 30.5827C132.166 30.5739 132.494 30.8849 132.503 31.2773C132.512 31.67 132.198 31.9951 131.801 32.0036V32.0039Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.482 32.0133L132.511 31.98V32.0133H132.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.419 32.0129L132.511 31.9077V31.9796L132.482 32.0129H132.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.356 32.013L132.512 31.8359V31.9078L132.42 32.013H132.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.293 32.0131L132.512 31.7642V31.836L132.357 32.0131H132.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23 32.0132L132.512 31.6924V31.7643L132.293 32.0132H132.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.167 32.0128L132.511 31.6201V31.692L132.23 32.0128H132.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.104 32.0129L132.511 31.5483V31.6202L132.167 32.0129H132.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.041 32.013L132.512 31.4766V31.5484L132.104 32.013H132.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.978 32.0131L132.512 31.4048V31.4767L132.041 32.0131H131.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.915 32.0132L132.512 31.333V31.4049L131.978 32.0132H131.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.852 32.0128L132.512 31.2607V31.3326L131.915 32.0128H131.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.789 32.0129L132.512 31.189V31.2608L131.852 32.0129H131.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.726 32.013L132.512 31.1172V31.1891L131.789 32.013H131.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.663 32.0131L132.512 31.0454V31.1173L131.726 32.0131H131.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.6 32.0127L132.512 30.9731V31.045L131.663 32.0127H131.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.537 32.0128L132.512 30.9014V30.9732L131.6 32.0128H131.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.473 32.0129L132.512 30.8296V30.9015L131.536 32.0129H131.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.411 32.013L132.512 30.7578V30.8297L131.473 32.013H131.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.348 32.0131L132.512 30.686V30.7579L131.411 32.0131H131.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.285 32.0132L132.512 30.6143V30.6861L131.348 32.0132H131.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.221 32.0129L132.484 30.5737H132.512V30.6139L131.285 32.0129H131.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.158 32.0129L132.421 30.5737H132.484L131.221 32.0129H131.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.095 32.0129L132.358 30.5737H132.421L131.158 32.0129H131.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.9831L132.295 30.5737H132.358L131.095 32.0129H131.059V31.9831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.9112L132.232 30.5737H132.295L131.059 31.9831V31.9112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.8393L132.169 30.5737H132.232L131.059 31.9112V31.8393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.7674L132.106 30.5737H132.169L131.059 31.8393V31.7674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.6955L132.043 30.5737H132.106L131.059 31.7674V31.6955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.6237L131.979 30.5737H132.043L131.059 31.6955V31.6237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.5518L131.916 30.5737H131.979L131.059 31.6237V31.5518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.4799L131.853 30.5737H131.916L131.059 31.5518V31.4799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.408L131.79 30.5737H131.853L131.059 31.4799V31.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.3362L131.727 30.5737H131.79L131.059 31.408V31.3362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.2643L131.664 30.5737H131.727L131.059 31.3362V31.2643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.1924L131.601 30.5737H131.664L131.059 31.2643V31.1924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.1205L131.538 30.5737H131.601L131.059 31.1924V31.1205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 31.0486L131.475 30.5737H131.538L131.059 31.1205V31.0486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.9768L131.412 30.5737H131.475L131.059 31.0486V30.9768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.9049L131.349 30.5737H131.412L131.059 30.9768V30.9049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.833L131.286 30.5737H131.349L131.059 30.9049V30.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.7611L131.223 30.5737H131.286L131.059 30.833V30.7611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.6892L131.16 30.5737H131.223L131.059 30.7611V30.6892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.059 30.6174L131.097 30.5737H131.16L131.059 30.6892V30.6174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.097 30.5737L131.059 30.6174V30.5737H131.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.869 35.5771L134.27 31.6997V35.5771H130.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.806 35.5772L134.27 31.6279V31.6998L130.869 35.5772H130.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.743 35.5773L134.27 31.5562V31.628L130.806 35.5773H130.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68 35.5769L134.27 31.4839V31.5558L130.743 35.5769H130.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.617 35.577L134.27 31.4121V31.484L130.68 35.577H130.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.553 35.5771L134.27 31.3403V31.4122L130.617 35.5771H130.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.49 35.5772L134.271 31.2686V31.3404L130.554 35.5772H130.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.427 35.5773L134.271 31.1968V31.2687L130.49 35.5773H130.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.364 35.5769L134.271 31.1245V31.1964L130.427 35.5769H130.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.301 35.577L134.271 31.0527V31.1246L130.364 35.577H130.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.238 35.5771L134.27 30.981V31.0528L130.301 35.5771H130.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.175 35.5772L134.27 30.9092V30.9811L130.238 35.5772H130.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.112 35.5774L134.271 30.8374V30.9093L130.175 35.5774H130.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.049 35.577L134.271 30.7651V30.837L130.112 35.577H130.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.986 35.5771L134.271 30.6934V30.7652L130.049 35.5771H129.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.923 35.5772L134.27 30.6216V30.6935L129.986 35.5772H129.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86 35.577L134.271 30.5498V30.6214L129.923 35.577H129.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.797 35.5771L134.271 30.478V30.5499L129.86 35.5771H129.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.734 35.5772L134.271 30.4062V30.4781L129.797 35.5772H129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67 35.5773L134.27 30.3345V30.4064L129.733 35.5773H129.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.607 35.5774L134.27 30.2627V30.3346L129.67 35.5774H129.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.545 35.577L134.271 30.1904V30.2623L129.608 35.577H129.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.482 35.5771L134.27 30.1187V30.1905L129.545 35.5771H129.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.418 35.5772L134.27 30.0469V30.1188L129.482 35.5772H129.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.355 35.5773L134.27 29.9751V30.047L129.418 35.5773H129.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.5692L134.271 29.9033V29.9752L129.356 35.5774H129.299V35.5692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.497L134.271 29.8311V29.9029L129.299 35.5688V35.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.4252L134.271 29.7593V29.8312L129.299 35.4971V35.4252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.3534L134.271 29.6875V29.7594L129.299 35.4253V35.3534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.2816L134.271 29.6157V29.6876L129.299 35.3535V35.2816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.2094L134.271 29.5435V29.6153L129.299 35.2812V35.2094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.1376L134.271 29.4717V29.5436L129.299 35.2095V35.1376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 35.0658L134.271 29.3999V29.4718L129.299 35.1377V35.0658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.994L134.271 29.3281V29.4L129.299 35.0659V34.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.9223L134.271 29.2563V29.3282L129.299 34.9941V34.9223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.85L134.271 29.1841V29.256L129.299 34.9219V34.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.7782L134.271 29.1123V29.1842L129.299 34.8501V34.7782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.7067L134.271 29.0405V29.1124L129.299 34.7783V34.7067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.635L134.271 28.9688V29.0406L129.299 34.7068V34.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.5632L134.271 28.897V28.9689L129.299 34.6351V34.5632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 34.4909L134.271 28.8247V28.8966L129.299 34.5628V34.4909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.4193L134.249 28.7778H134.271V28.8249L129.3 34.4911V34.4193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.3474L134.186 28.7778H134.249L129.3 34.4193V34.3474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.2755L134.123 28.7778H134.186L129.3 34.3474V34.2755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.2036L134.06 28.7778H134.123L129.3 34.2755V34.2036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.1317L133.997 28.7778H134.06L129.3 34.2036V34.1317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 34.0599L133.934 28.7778H133.997L129.3 34.1317V34.0599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.988L133.871 28.7778H133.934L129.3 34.0599V33.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.9161L133.808 28.7778H133.871L129.3 33.988V33.9161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.8442L133.744 28.7778H133.808L129.3 33.9161V33.8442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.7723L133.682 28.7778H133.744L129.3 33.8442V33.7723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.7005L133.619 28.7778H133.682L129.3 33.7723V33.7005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.6286L133.556 28.7778H133.619L129.3 33.7005V33.6286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.5567L133.492 28.7778H133.556L129.3 33.6286V33.5567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.4848L133.429 28.7778H133.492L129.3 33.5567V33.4848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.4129L133.366 28.7778H133.429L129.3 33.4848V33.4129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.3411L133.303 28.7778H133.366L129.3 33.4129V33.3411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.2692L133.24 28.7778H133.303L129.3 33.3411V33.2692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.1973L133.177 28.7778H133.24L129.3 33.2692V33.1973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.1254L133.114 28.7778H133.177L129.3 33.1973V33.1254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 33.0535L133.051 28.7778H133.114L129.3 33.1254V33.0535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.9817L132.988 28.7778H133.051L129.3 33.0535V32.9817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.9098L132.925 28.7778H132.988L129.3 32.9817V32.9098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.8379L132.862 28.7778H132.925L129.3 32.9098V32.8379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.766L132.799 28.7778H132.862L129.3 32.8379V32.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.6942L132.736 28.7778H132.799L129.3 32.766V32.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.6223L132.673 28.7778H132.736L129.3 32.6942V32.6223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.5504L132.61 28.7778H132.673L129.3 32.6223V32.5504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.4785L132.546 28.7778H132.61L129.3 32.5504V32.4785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.4066L132.483 28.7778H132.546L129.3 32.4785V32.4066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.3348L132.42 28.7778H132.483L129.3 32.4066V32.3348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.2629L132.358 28.7778H132.42L129.3 32.3348V32.2629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.191L132.294 28.7778H132.358L129.3 32.2629V32.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.1191L132.231 28.7778H132.294L129.3 32.191V32.1191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 32.0476L132.168 28.7778H132.231L129.3 32.1191V32.0476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.9757L132.105 28.7778H132.168L129.3 32.0476V31.9757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.9038L132.042 28.7778H132.105L129.3 31.9757V31.9038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.8319L131.979 28.7778H132.042L129.3 31.9038V31.8319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.76L131.916 28.7778H131.979L129.3 31.8319V31.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.6882L131.853 28.7778H131.916L129.3 31.76V31.6882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.6163L131.79 28.7778H131.853L129.3 31.6882V31.6163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.5444L131.727 28.7778H131.79L129.3 31.6163V31.5444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.4725L131.664 28.7778H131.727L129.3 31.5444V31.4725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.4006L131.601 28.7778H131.664L129.3 31.4725V31.4006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.3288L131.538 28.7778H131.601L129.3 31.4006V31.3288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.2569L131.475 28.7778H131.538L129.3 31.3288V31.2569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.185L131.412 28.7778H131.475L129.3 31.2569V31.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.1131L131.348 28.7778H131.412L129.3 31.185V31.1131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 31.0412L131.285 28.7778H131.348L129.3 31.1131V31.0412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 30.9694L131.222 28.7778H131.285L129.3 31.0412V30.9694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 30.8975L131.159 28.7778H131.222L129.3 30.9694V30.8975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 30.8256L131.096 28.7778H131.159L129.3 30.8975V30.8256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 30.7537L131.033 28.7778H131.096L129.3 30.8256V30.7537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.033 28.7778L129.3 30.7537V28.7778H131.033Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.671 51.1293L137.684 51.2523C137.796 52.3286 136.988 53.3132 135.901 53.4244L135.572 53.458L134.129 39.6383L136.242 39.422L135.841 35.5767L131.944 37.503L134.035 57.5325L136.306 57.2999C139.537 56.969 141.873 54.0873 141.539 50.8891L141.526 50.7661L137.671 51.1293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 35,
    width: 11,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.671 51.1293L137.684 51.2523C137.796 52.3286 136.988 53.3132 135.901 53.4244L135.572 53.458L134.129 39.6383L136.242 39.422L135.841 35.5767L131.944 37.503L134.035 57.5325L136.306 57.2999C139.537 56.969 141.873 54.0873 141.539 50.8891L141.526 50.7661L137.671 51.1293Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.943 37.5029L134.034 57.5324H131.943V37.5029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.943 36.6499L134.123 57.5329H134.034L131.943 37.5034V36.6499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.943 35.7959L134.212 57.5326H134.123L131.943 36.6497V35.7959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.009 35.5771L134.301 57.5326H134.212L131.943 35.7959V35.5771H132.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.099 35.5771L134.391 57.5326H134.302L132.01 35.5771H132.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.188 35.5771L134.48 57.5326H134.391L132.099 35.5771H132.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.277 35.5771L134.569 57.5326H134.48L132.188 35.5771H132.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.366 35.5771L134.658 57.5326H134.569L132.277 35.5771H132.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.455 35.5771L134.747 57.5326H134.658L132.366 35.5771H132.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.544 35.5771L134.836 57.5326H134.747L132.455 35.5771H132.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.633 35.5771L134.925 57.5326H134.836L132.544 35.5771H132.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.722 35.5771L135.014 57.5326H134.925L132.633 35.5771H132.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.812 35.5771L135.104 57.5326H135.015L132.723 35.5771H132.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.901 35.5771L135.193 57.5326H135.104L132.812 35.5771H132.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.99 35.5771L135.282 57.5326H135.193L132.901 35.5771H132.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.079 35.5771L135.371 57.5326H135.282L132.99 35.5771H133.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.168 35.5771L135.46 57.5326H135.371L133.079 35.5771H133.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.257 35.5771L135.549 57.5326H135.46L133.168 35.5771H133.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.346 35.5771L135.638 57.5326H135.549L133.257 35.5771H133.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.435 35.5771L135.727 57.5326H135.638L133.346 35.5771H133.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.524 35.5771L135.816 57.5326H135.727L133.435 35.5771H133.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.614 35.5771L135.906 57.5326H135.817L133.525 35.5771H133.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.703 35.5771L135.995 57.5326H135.906L133.614 35.5771H133.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.792 35.5771L136.084 57.5326H135.995L133.703 35.5771H133.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.881 35.5771L136.173 57.5326H136.084L133.792 35.5771H133.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.97 35.5771L136.262 57.5326H136.173L133.881 35.5771H133.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.059 35.5771L136.351 57.5326H136.262L133.97 35.5771H134.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.148 35.5771L136.44 57.5326H136.351L134.059 35.5771H134.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.237 35.5771L136.529 57.5326H136.44L134.148 35.5771H134.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.327 35.5771L136.619 57.5326H136.529L134.237 35.5771H134.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.416 35.5771L136.708 57.5326H136.619L134.327 35.5771H134.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.505 35.5771L136.797 57.5326H136.708L134.416 35.5771H134.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.594 35.5771L136.886 57.5326H136.797L134.505 35.5771H134.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.683 35.5771L136.975 57.5326H136.886L134.594 35.5771H134.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.772 35.5771L137.064 57.5326H136.975L134.683 35.5771H134.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.861 35.5771L137.153 57.5326H137.064L134.772 35.5771H134.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.95 35.5771L137.242 57.5326H137.153L134.861 35.5771H134.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.039 35.5771L137.331 57.5326H137.242L134.95 35.5771H135.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.128 35.5771L137.42 57.5326H137.331L135.039 35.5771H135.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.218 35.5771L137.51 57.5326H137.42L135.128 35.5771H135.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.307 35.5771L137.599 57.5326H137.51L135.218 35.5771H135.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.396 35.5771L137.688 57.5326H137.599L135.307 35.5771H135.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.485 35.5771L137.777 57.5326H137.688L135.396 35.5771H135.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.574 35.5771L137.866 57.5326H137.777L135.485 35.5771H135.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.663 35.5771L137.955 57.5326H137.866L135.574 35.5771H135.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.752 35.5771L138.044 57.5326H137.955L135.663 35.5771H135.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.841 35.5771L138.133 57.5326H138.044L135.752 35.5771H135.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93 35.5771L138.222 57.5326H138.133L135.841 35.5771H135.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.02 35.5771L138.312 57.5326H138.223L135.931 35.5771H136.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.109 35.5771L138.401 57.5326H138.311L136.019 35.5771H136.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.198 35.5771L138.49 57.5326H138.401L136.109 35.5771H136.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.287 35.5771L138.579 57.5326H138.49L136.198 35.5771H136.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.376 35.5771L138.668 57.5326H138.579L136.287 35.5771H136.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.465 35.5771L138.757 57.5326H138.668L136.376 35.5771H136.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.554 35.5771L138.846 57.5326H138.757L136.465 35.5771H136.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.643 35.5771L138.935 57.5326H138.846L136.554 35.5771H136.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.732 35.5771L139.024 57.5326H138.935L136.643 35.5771H136.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.822 35.5771L139.114 57.5326H139.025L136.733 35.5771H136.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91 35.5771L139.202 57.5326H139.113L136.821 35.5771H136.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 35.5771L139.292 57.5326H139.203L136.911 35.5771H137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.089 35.5771L139.381 57.5326H139.292L137 35.5771H137.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.178 35.5771L139.47 57.5326H139.381L137.089 35.5771H137.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.267 35.5771L139.559 57.5326H139.47L137.178 35.5771H137.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.356 35.5771L139.648 57.5326H139.559L137.267 35.5771H137.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.445 35.5771L139.737 57.5326H139.648L137.356 35.5771H137.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.535 35.5771L139.827 57.5326H139.738L137.446 35.5771H137.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.624 35.5771L139.916 57.5326H139.827L137.535 35.5771H137.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.713 35.5771L140.005 57.5326H139.916L137.624 35.5771H137.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.802 35.5771L140.094 57.5326H140.005L137.713 35.5771H137.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.891 35.5771L140.183 57.5326H140.094L137.801 35.5771H137.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.98 35.5771L140.272 57.5326H140.183L137.891 35.5771H137.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.069 35.5771L140.361 57.5326H140.272L137.98 35.5771H138.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.158 35.5771L140.45 57.5326H140.361L138.069 35.5771H138.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.247 35.5771L140.539 57.5326H140.45L138.158 35.5771H138.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.337 35.5771L140.629 57.5326H140.54L138.248 35.5771H138.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.426 35.5771L140.718 57.5326H140.629L138.337 35.5771H138.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.515 35.5771L140.807 57.5326H140.718L138.426 35.5771H138.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.604 35.5771L140.896 57.5326H140.807L138.515 35.5771H138.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.693 35.5771L140.985 57.5326H140.896L138.604 35.5771H138.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.782 35.5771L141.074 57.5326H140.985L138.693 35.5771H138.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.871 35.5771L141.163 57.5326H141.074L138.782 35.5771H138.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.96 35.5771L141.252 57.5326H141.163L138.871 35.5771H138.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.049 35.5771L141.341 57.5326H141.252L138.96 35.5771H139.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.139 35.5771L141.431 57.5326H141.342L139.05 35.5771H139.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.228 35.5771L141.52 57.5326H141.431L139.139 35.5771H139.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.317 35.5771L141.609 57.5326H141.52L139.228 35.5771H139.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.406 35.5771L141.698 57.5326H141.609L139.316 35.5771H139.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.495 35.5771L141.787 57.5326H141.698L139.406 35.5771H139.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.584 35.5771L141.873 57.5022V57.5326H141.787L139.495 35.5771H139.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.673 35.5771L141.873 56.6487V57.5022L139.584 35.5771H139.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.762 35.5771L141.873 55.795V56.6487L139.673 35.5771H139.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.852 35.5771L141.873 54.9415V55.795L139.763 35.5771H139.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.941 35.5771L141.873 54.0878V54.9415L139.852 35.5771H139.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.873 54.0878L139.941 35.5771H141.873V54.0878Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.73 36.4072L128.131 40.2526L130.245 40.0363L131.688 53.856L131.562 53.8689C130.474 53.9803 129.481 53.1799 129.369 52.1036L129.356 51.9805L125.475 52.4093L125.488 52.5323C125.822 55.7308 128.736 58.0752 131.967 57.7447L134.034 57.5331L131.943 37.5036L127.73 36.4075V36.4072Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 36,
    width: 10,
    height: 22
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.73 36.4072L128.131 40.2526L130.245 40.0363L131.688 53.856L131.562 53.8689C130.474 53.9803 129.481 53.1799 129.369 52.1036L129.356 51.9805L125.475 52.4093L125.488 52.5323C125.822 55.7308 128.736 58.0752 131.967 57.7447L134.034 57.5331L131.943 37.5036L127.73 36.4075V36.4072Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.475 52.4092L126.067 58.0754H125.475V52.4092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 51.5737L126.154 58.0752H126.067L125.475 52.409V51.5737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 50.7383L126.241 58.0753H126.154L125.475 51.5738V50.7383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 49.9028L126.328 58.0754H126.241L125.475 50.7384V49.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 49.0669L126.416 58.075H126.328L125.475 49.9025V49.0669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 48.2319L126.503 58.0753H126.416L125.475 49.0672V48.2319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 47.3965L126.59 58.0754H126.503L125.475 48.232V47.3965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 46.5605L126.677 58.075H126.59L125.475 47.3961V46.5605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 45.7256L126.764 58.0753H126.677L125.475 46.5608V45.7256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 44.8901L126.852 58.0754H126.764L125.475 45.7257V44.8901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 44.0542L126.939 58.075H126.852L125.475 44.8898V44.0542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 43.2188L127.026 58.0752H126.939L125.475 44.0543V43.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 42.3833L127.113 58.0749H127.026L125.475 43.2185V42.3833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 41.5479L127.201 58.0751H127.113L125.475 42.3834V41.5479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 40.7124L127.288 58.0752H127.201L125.475 41.548V40.7124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 39.877L127.375 58.0753H127.288L125.475 40.7125V39.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 39.0415L127.462 58.0751H127.375L125.475 39.8767V39.0415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 38.2061L127.549 58.0752H127.462L125.475 39.0416V38.2061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 37.3706L127.637 58.0753H127.549L125.475 38.2062V37.3706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.475 36.5352L127.724 58.0751H127.637L125.475 37.3704V36.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.549 36.4072L127.811 58.0752H127.724L125.475 36.5353V36.4072H125.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.637 36.4072L127.898 58.0752H127.811L125.549 36.4072H125.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.724 36.4072L127.986 58.0752H127.898L125.637 36.4072H125.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.811 36.4072L128.073 58.0752H127.986L125.724 36.4072H125.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.898 36.4072L128.16 58.0752H128.073L125.811 36.4072H125.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.985 36.4072L128.247 58.0752H128.16L125.898 36.4072H125.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.073 36.4072L128.334 58.0752H128.247L125.985 36.4072H126.073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.16 36.4072L128.422 58.0752H128.334L126.072 36.4072H126.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.247 36.4072L128.509 58.0752H128.421L126.16 36.4072H126.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.334 36.4072L128.596 58.0752H128.509L126.247 36.4072H126.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.422 36.4072L128.684 58.0752H128.596L126.334 36.4072H126.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.509 36.4072L128.771 58.0752H128.684L126.422 36.4072H126.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.596 36.4072L128.858 58.0752H128.771L126.509 36.4072H126.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.683 36.4072L128.945 58.0752H128.858L126.596 36.4072H126.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77 36.4072L129.032 58.0752H128.945L126.683 36.4072H126.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.857 36.4072L129.119 58.0752H129.032L126.77 36.4072H126.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.944 36.4072L129.207 58.0752H129.119L126.857 36.4072H126.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.032 36.4072L129.294 58.0752H129.207L126.945 36.4072H127.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.119 36.4072L129.381 58.0752H129.294L127.032 36.4072H127.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.206 36.4072L129.468 58.0752H129.381L127.119 36.4072H127.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.294 36.4072L129.555 58.0752H129.468L127.206 36.4072H127.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.381 36.4072L129.643 58.0752H129.556L127.294 36.4072H127.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.468 36.4072L129.73 58.0752H129.643L127.381 36.4072H127.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.555 36.4072L129.817 58.0752H129.73L127.468 36.4072H127.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.642 36.4072L129.904 58.0752H129.817L127.555 36.4072H127.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.729 36.4072L129.992 58.0752H129.904L127.642 36.4072H127.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.817 36.4072L130.079 58.0752H129.992L127.729 36.4072H127.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.904 36.4072L130.166 58.0752H130.079L127.817 36.4072H127.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.992 36.4072L130.253 58.0752H130.166L127.904 36.4072H127.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.079 36.4072L130.341 58.0752H130.253L127.991 36.4072H128.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.166 36.4072L130.428 58.0752H130.341L128.079 36.4072H128.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.253 36.4072L130.515 58.0752H130.428L128.166 36.4072H128.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34 36.4072L130.602 58.0752H130.515L128.253 36.4072H128.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.427 36.4072L130.689 58.0752H130.602L128.34 36.4072H128.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.514 36.4072L130.776 58.0752H130.689L128.427 36.4072H128.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.602 36.4072L130.864 58.0752H130.777L128.515 36.4072H128.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.689 36.4072L130.951 58.0752H130.864L128.602 36.4072H128.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.776 36.4072L131.038 58.0752H130.951L128.689 36.4072H128.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.863 36.4072L131.125 58.0752H131.038L128.776 36.4072H128.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.951 36.4072L131.213 58.0752H131.126L128.864 36.4072H128.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.038 36.4072L131.3 58.0752H131.213L128.951 36.4072H129.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.125 36.4072L131.387 58.0752H131.3L129.038 36.4072H129.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.212 36.4072L131.474 58.0752H131.387L129.125 36.4072H129.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 36.4072L131.562 58.0752H131.474L129.212 36.4072H129.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.387 36.4072L131.649 58.0752H131.562L129.3 36.4072H129.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.474 36.4072L131.736 58.0752H131.649L129.387 36.4072H129.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.561 36.4072L131.823 58.0752H131.736L129.474 36.4072H129.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.648 36.4072L131.91 58.0752H131.823L129.561 36.4072H129.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.736 36.4072L131.998 58.0752H131.91L129.648 36.4072H129.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.823 36.4072L132.085 58.0752H131.997L129.736 36.4072H129.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91 36.4072L132.172 58.0752H132.085L129.823 36.4072H129.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.997 36.4072L132.259 58.0752H132.172L129.91 36.4072H129.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.084 36.4072L132.346 58.0752H132.259L129.997 36.4072H130.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.172 36.4072L132.434 58.0752H132.347L130.085 36.4072H130.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.259 36.4072L132.521 58.0752H132.434L130.172 36.4072H130.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.346 36.4072L132.608 58.0752H132.521L130.259 36.4072H130.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.433 36.4072L132.695 58.0752H132.608L130.346 36.4072H130.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.521 36.4072L132.783 58.0752H132.695L130.434 36.4072H130.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.608 36.4072L132.87 58.0752H132.783L130.521 36.4072H130.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.695 36.4072L132.957 58.0752H132.87L130.608 36.4072H130.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.782 36.4072L133.044 58.0752H132.957L130.695 36.4072H130.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.87 36.4072L133.131 58.0752H133.044L130.782 36.4072H130.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.957 36.4072L133.219 58.0752H133.132L130.87 36.4072H130.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.044 36.4072L133.306 58.0752H133.219L130.957 36.4072H131.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.131 36.4072L133.393 58.0752H133.306L131.044 36.4072H131.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.218 36.4072L133.48 58.0752H133.393L131.131 36.4072H131.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.305 36.4072L133.567 58.0752H133.48L131.218 36.4072H131.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.393 36.4072L133.655 58.0752H133.567L131.305 36.4072H131.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48 36.4072L133.742 58.0752H133.655L131.392 36.4072H131.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.568 36.4072L133.829 58.0752H133.742L131.48 36.4072H131.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.655 36.4072L133.917 58.0752H133.829L131.567 36.4072H131.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.742 36.4072L134.004 58.0752H133.916L131.655 36.4072H131.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.829 36.4072L134.034 57.5328V58.0752H134.004L131.742 36.4072H131.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.034 57.5328L131.829 36.4072H134.034V57.5328Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.84 35.5771L131.786 35.9921H131.784L127.73 36.4071L131.943 37.5031L135.84 35.5771Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 35,
    width: 9,
    height: 3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.84 35.5771L131.786 35.9921H131.784L127.73 36.4071L131.943 37.5031L135.84 35.5771Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.73 36.4072L127.845 37.5033H127.73V36.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.733 35.5771L127.934 37.5031H127.845L127.73 36.4071V35.5771H127.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.822 35.5771L128.023 37.5031H127.934L127.733 35.5771H127.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.911 35.5771L128.112 37.5031H128.023L127.822 35.5771H127.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 35.5771L128.201 37.5031H128.112L127.911 35.5771H128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.089 35.5771L128.29 37.5031H128.201L128 35.5771H128.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.178 35.5771L128.379 37.5031H128.29L128.089 35.5771H128.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.268 35.5771L128.469 37.5031H128.38L128.179 35.5771H128.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 35.5771L128.557 37.5031H128.468L128.267 35.5771H128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.446 35.5771L128.647 37.5031H128.558L128.357 35.5771H128.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.535 35.5771L128.736 37.5031H128.647L128.446 35.5771H128.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.624 35.5771L128.825 37.5031H128.736L128.535 35.5771H128.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.713 35.5771L128.914 37.5031H128.825L128.624 35.5771H128.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.802 35.5771L129.003 37.5031H128.914L128.713 35.5771H128.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.891 35.5771L129.092 37.5031H129.003L128.802 35.5771H128.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.98 35.5771L129.182 37.5031H129.093L128.891 35.5771H128.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.069 35.5771L129.271 37.5031H129.182L128.98 35.5771H129.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.158 35.5771L129.36 37.5031H129.271L129.069 35.5771H129.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.247 35.5771L129.449 37.5031H129.36L129.158 35.5771H129.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.337 35.5771L129.538 37.5031H129.449L129.248 35.5771H129.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.426 35.5771L129.627 37.5031H129.538L129.337 35.5771H129.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.515 35.5771L129.716 37.5031H129.627L129.426 35.5771H129.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.604 35.5771L129.805 37.5031H129.716L129.515 35.5771H129.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.693 35.5771L129.894 37.5031H129.805L129.604 35.5771H129.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.782 35.5771L129.983 37.5031H129.894L129.693 35.5771H129.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.871 35.5771L130.072 37.5031H129.983L129.782 35.5771H129.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.96 35.5771L130.161 37.5031H130.072L129.871 35.5771H129.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.049 35.5771L130.25 37.5031H130.161L129.96 35.5771H130.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.139 35.5771L130.34 37.5031H130.251L130.05 35.5771H130.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.228 35.5771L130.429 37.5031H130.34L130.139 35.5771H130.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.317 35.5771L130.518 37.5031H130.429L130.228 35.5771H130.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.406 35.5771L130.607 37.5031H130.518L130.317 35.5771H130.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.495 35.5771L130.696 37.5031H130.607L130.406 35.5771H130.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.584 35.5771L130.785 37.5031H130.696L130.495 35.5771H130.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.673 35.5771L130.874 37.5031H130.785L130.584 35.5771H130.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.762 35.5771L130.963 37.5031H130.874L130.673 35.5771H130.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.851 35.5771L131.053 37.5031H130.964L130.762 35.5771H130.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.94 35.5771L131.142 37.5031H131.053L130.851 35.5771H130.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.03 35.5771L131.231 37.5031H131.142L130.94 35.5771H131.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.119 35.5771L131.32 37.5031H131.231L131.03 35.5771H131.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.208 35.5771L131.409 37.5031H131.32L131.119 35.5771H131.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.297 35.5771L131.498 37.5031H131.409L131.208 35.5771H131.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.386 35.5771L131.587 37.5031H131.498L131.297 35.5771H131.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.475 35.5771L131.676 37.5031H131.587L131.386 35.5771H131.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.564 35.5771L131.765 37.5031H131.676L131.475 35.5771H131.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.653 35.5771L131.854 37.5031H131.765L131.564 35.5771H131.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.742 35.5771L131.943 37.5031H131.854L131.653 35.5771H131.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.831 35.5771L132.032 37.5031H131.943L131.742 35.5771H131.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92 35.5771L132.121 37.5031H132.032L131.831 35.5771H131.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.01 35.5771L132.211 37.5031H132.122L131.921 35.5771H132.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.099 35.5771L132.3 37.5031H132.211L132.01 35.5771H132.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.188 35.5771L132.389 37.5031H132.3L132.099 35.5771H132.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.277 35.5771L132.478 37.5031H132.389L132.188 35.5771H132.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.366 35.5771L132.567 37.5031H132.478L132.277 35.5771H132.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.455 35.5771L132.656 37.5031H132.567L132.366 35.5771H132.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.544 35.5771L132.745 37.5031H132.656L132.455 35.5771H132.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.633 35.5771L132.834 37.5031H132.745L132.544 35.5771H132.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.723 35.5771L132.924 37.5031H132.835L132.634 35.5771H132.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.812 35.5771L133.013 37.5031H132.924L132.723 35.5771H132.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.901 35.5771L133.102 37.5031H133.013L132.812 35.5771H132.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.99 35.5771L133.191 37.5031H133.102L132.901 35.5771H132.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.079 35.5771L133.28 37.5031H133.191L132.99 35.5771H133.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.168 35.5771L133.369 37.5031H133.28L133.079 35.5771H133.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.257 35.5771L133.458 37.5031H133.369L133.168 35.5771H133.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.346 35.5771L133.547 37.5031H133.458L133.257 35.5771H133.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.435 35.5771L133.636 37.5031H133.547L133.346 35.5771H133.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.524 35.5771L133.725 37.5031H133.636L133.435 35.5771H133.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.613 35.5771L133.814 37.5031H133.725L133.524 35.5771H133.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.702 35.5771L133.903 37.5031H133.814L133.613 35.5771H133.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.791 35.5771L133.992 37.5031H133.903L133.702 35.5771H133.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.881 35.5771L134.082 37.5031H133.993L133.792 35.5771H133.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.97 35.5771L134.171 37.5031H134.082L133.881 35.5771H133.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.059 35.5771L134.26 37.5031H134.171L133.969 35.5771H134.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.148 35.5771L134.349 37.5031H134.26L134.058 35.5771H134.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.237 35.5771L134.438 37.5031H134.349L134.148 35.5771H134.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.326 35.5771L134.527 37.5031H134.438L134.237 35.5771H134.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.416 35.5771L134.617 37.5031H134.528L134.327 35.5771H134.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.504 35.5771L134.705 37.5031H134.616L134.415 35.5771H134.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.594 35.5771L134.795 37.5031H134.706L134.505 35.5771H134.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.683 35.5771L134.884 37.5031H134.795L134.594 35.5771H134.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.772 35.5771L134.973 37.5031H134.884L134.683 35.5771H134.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.861 35.5771L135.062 37.5031H134.972L134.771 35.5771H134.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.95 35.5771L135.151 37.5031H135.062L134.861 35.5771H134.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.039 35.5771L135.24 37.5031H135.151L134.95 35.5771H135.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.128 35.5771L135.329 37.5031H135.24L135.039 35.5771H135.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.217 35.5771L135.418 37.5031H135.329L135.128 35.5771H135.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.306 35.5771L135.507 37.5031H135.418L135.217 35.5771H135.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.395 35.5771L135.596 37.5031H135.507L135.306 35.5771H135.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.484 35.5771L135.686 37.5031H135.596L135.395 35.5771H135.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.574 35.5771L135.775 37.5031H135.686L135.484 35.5771H135.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.663 35.5771L135.841 37.284V37.5031H135.775L135.573 35.5771H135.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.752 35.5771L135.841 36.4306V37.284L135.662 35.5771H135.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.841 36.4306L135.751 35.5771H135.841V36.4306Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.699 54.2285C123.699 54.2285 126 60.4594 133.683 58.6605C140.23 57.1279 142.083 59.2145 142.083 59.2145C142.083 59.2145 138.809 57.6078 133.683 59.6025C128.558 61.5969 123.386 59.7431 123.699 54.2285Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 54,
    width: 20,
    height: 7
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.699 54.2285C123.699 54.2285 126 60.4594 133.683 58.6605C140.23 57.1279 142.083 59.2145 142.083 59.2145C142.083 59.2145 138.809 57.6078 133.683 59.6025C128.558 61.5969 123.386 59.7431 123.699 54.2285Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.685 54.2285H123.386V61.5969H123.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.885 54.2285H123.685V61.5969H123.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.085 54.2285H123.885V61.5969H124.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.285 54.2285H124.085V61.5969H124.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.485 54.2285H124.285V61.5969H124.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.685 54.2285H124.485V61.5969H124.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.885 54.2285H124.685V61.5969H124.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.085 54.2285H124.885V61.5969H125.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.285 54.2285H125.085V61.5969H125.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.485 54.2285H125.285V61.5969H125.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.685 54.2285H125.485V61.5969H125.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.885 54.2285H125.685V61.5969H125.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.085 54.2285H125.885V61.5969H126.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.285 54.2285H126.085V61.5969H126.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.485 54.2285H126.285V61.5969H126.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.685 54.2285H126.485V61.5969H126.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.885 54.2285H126.685V61.5969H126.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.085 54.2285H126.885V61.5969H127.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.285 54.2285H127.085V61.5969H127.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.485 54.2285H127.285V61.5969H127.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.685 54.2285H127.485V61.5969H127.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.885 54.2285H127.685V61.5969H127.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.085 54.2285H127.885V61.5969H128.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.285 54.2285H128.085V61.5969H128.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.485 54.2285H128.285V61.5969H128.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.685 54.2285H128.485V61.5969H128.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.885 54.2285H128.685V61.5969H128.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.085 54.2285H128.885V61.5969H129.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.285 54.2285H129.085V61.5969H129.285V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.485 54.2285H129.285V61.5969H129.485V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.685 54.2285H129.485V61.5969H129.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.885 54.2285H129.685V61.5969H129.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.085 54.2285H129.885V61.5969H130.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.284 54.2285H130.084V61.5969H130.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.484 54.2285H130.284V61.5969H130.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.685 54.2285H130.485V61.5969H130.685V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.884 54.2285H130.684V61.5969H130.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.084 54.2285H130.884V61.5969H131.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.284 54.2285H131.084V61.5969H131.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.484 54.2285H131.284V61.5969H131.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.684 54.2285H131.484V61.5969H131.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.885 54.2285H131.685V61.5969H131.885V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.085 54.2285H131.885V61.5969H132.085V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.284 54.2285H132.084V61.5969H132.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.484 54.2285H132.284V61.5969H132.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.684 54.2285H132.484V61.5969H132.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.884 54.2285H132.684V61.5969H132.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.084 54.2285H132.884V61.5969H133.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.284 54.2285H133.084V61.5969H133.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.484 54.2285H133.284V61.5969H133.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.684 54.2285H133.484V61.5969H133.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.884 54.2285H133.684V61.5969H133.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.084 54.2285H133.884V61.5969H134.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.284 54.2285H134.084V61.5969H134.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.484 54.2285H134.284V61.5969H134.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.684 54.2285H134.484V61.5969H134.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.884 54.2285H134.684V61.5969H134.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.084 54.2285H134.884V61.5969H135.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.284 54.2285H135.084V61.5969H135.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.484 54.2285H135.284V61.5969H135.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.684 54.2285H135.484V61.5969H135.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.884 54.2285H135.684V61.5969H135.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.084 54.2285H135.884V61.5969H136.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.284 54.2285H136.084V61.5969H136.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.484 54.2285H136.284V61.5969H136.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.684 54.2285H136.484V61.5969H136.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.884 54.2285H136.684V61.5969H136.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.084 54.2285H136.884V61.5969H137.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.284 54.2285H137.084V61.5969H137.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.484 54.2285H137.284V61.5969H137.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.684 54.2285H137.484V61.5969H137.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.883 54.2285H137.683V61.5969H137.883V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.084 54.2285H137.884V61.5969H138.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.284 54.2285H138.084V61.5969H138.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.484 54.2285H138.284V61.5969H138.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.684 54.2285H138.484V61.5969H138.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.884 54.2285H138.684V61.5969H138.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.084 54.2285H138.884V61.5969H139.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.284 54.2285H139.084V61.5969H139.284V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.484 54.2285H139.284V61.5969H139.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.684 54.2285H139.484V61.5969H139.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.884 54.2285H139.684V61.5969H139.884V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.083 54.2285H139.883V61.5969H140.083V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.283 54.2285H140.083V61.5969H140.283V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.484 54.2285H140.283V61.5969H140.484V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.684 54.2285H140.484V61.5969H140.684V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.883 54.2285H140.683V61.5969H140.883V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.084 54.2285H140.883V61.5969H141.084V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.283 54.2285H141.083V61.5969H141.283V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.483 54.2285H141.283V61.5969H141.483V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.683 54.2285H141.483V61.5969H141.683V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.883 54.2285H141.683V61.5969H141.883V54.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.083 54.2285H141.883V61.5969H142.083V54.2285Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.944 58.4116C123.944 58.4116 125.289 62.0539 129.78 61.0024C133.607 60.1063 134.69 61.3263 134.69 61.3263C134.69 61.3263 132.776 60.3872 129.78 61.553C126.784 62.7187 123.761 61.6352 123.944 58.4116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1167_1586",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 58,
    width: 12,
    height: 5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.944 58.4116C123.944 58.4116 125.289 62.0539 129.78 61.0024C133.607 60.1063 134.69 61.3263 134.69 61.3263C134.69 61.3263 132.776 60.3872 129.78 61.553C126.784 62.7187 123.761 61.6352 123.944 58.4116Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1167_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.936 58.4116H123.761V62.7187H123.936V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.052 58.4116H123.935V62.7187H124.052V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17 58.4116H124.053V62.7187H124.17V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.287 58.4116H124.17V62.7187H124.287V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.403 58.4116H124.286V62.7187H124.403V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52 58.4116H124.403V62.7187H124.52V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.637 58.4116H124.52V62.7187H124.637V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.754 58.4116H124.637V62.7187H124.754V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.871 58.4116H124.754V62.7187H124.871V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.988 58.4116H124.871V62.7187H124.988V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 58.4116H124.988V62.7187H125.105V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.222 58.4116H125.105V62.7187H125.222V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.338 58.4116H125.221V62.7187H125.338V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.456 58.4116H125.339V62.7187H125.456V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.572 58.4116H125.455V62.7187H125.572V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.689 58.4116H125.572V62.7187H125.689V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.806 58.4116H125.689V62.7187H125.806V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.923 58.4116H125.806V62.7187H125.923V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.04 58.4116H125.923V62.7187H126.04V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.157 58.4116H126.04V62.7187H126.157V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.274 58.4116H126.157V62.7187H126.274V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.391 58.4116H126.274V62.7187H126.391V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.508 58.4116H126.391V62.7187H126.508V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.625 58.4116H126.508V62.7187H126.625V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.741 58.4116H126.624V62.7187H126.741V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.858 58.4116H126.741V62.7187H126.858V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.975 58.4116H126.858V62.7187H126.975V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.092 58.4116H126.975V62.7187H127.092V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.209 58.4116H127.092V62.7187H127.209V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.326 58.4116H127.209V62.7187H127.326V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.443 58.4116H127.326V62.7187H127.443V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.56 58.4116H127.443V62.7187H127.56V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.676 58.4116H127.559V62.7187H127.676V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.793 58.4116H127.676V62.7187H127.793V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.911 58.4116H127.794V62.7187H127.911V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.027 58.4116H127.91V62.7187H128.027V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.144 58.4116H128.027V62.7187H128.144V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.261 58.4116H128.144V62.7187H128.261V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.378 58.4116H128.261V62.7187H128.378V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.495 58.4116H128.378V62.7187H128.495V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.612 58.4116H128.495V62.7187H128.612V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.728 58.4116H128.611V62.7187H128.728V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.846 58.4116H128.729V62.7187H128.846V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.963 58.4116H128.846V62.7187H128.963V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.079 58.4116H128.962V62.7187H129.079V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.196 58.4116H129.079V62.7187H129.196V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.313 58.4116H129.196V62.7187H129.313V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43 58.4116H129.313V62.7187H129.43V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.547 58.4116H129.43V62.7187H129.547V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.664 58.4116H129.547V62.7187H129.664V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.781 58.4116H129.664V62.7187H129.781V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.898 58.4116H129.781V62.7187H129.898V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.014 58.4116H129.897V62.7187H130.014V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.132 58.4116H130.015V62.7187H130.132V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.248 58.4116H130.131V62.7187H130.248V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.365 58.4116H130.248V62.7187H130.365V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.482 58.4116H130.365V62.7187H130.482V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.599 58.4116H130.482V62.7187H130.599V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.716 58.4116H130.599V62.7187H130.716V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.833 58.4116H130.716V62.7187H130.833V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.95 58.4116H130.833V62.7187H130.95V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.067 58.4116H130.95V62.7187H131.067V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.184 58.4116H131.067V62.7187H131.184V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 58.4116H131.183V62.7187H131.3V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.417 58.4116H131.3V62.7187H131.417V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.534 58.4116H131.417V62.7187H131.534V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.651 58.4116H131.534V62.7187H131.651V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.768 58.4116H131.651V62.7187H131.768V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.885 58.4116H131.768V62.7187H131.885V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.002 58.4116H131.885V62.7187H132.002V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.119 58.4116H132.002V62.7187H132.119V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.236 58.4116H132.119V62.7187H132.236V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.352 58.4116H132.235V62.7187H132.352V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.469 58.4116H132.352V62.7187H132.469V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.586 58.4116H132.469V62.7187H132.586V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.704 58.4116H132.587V62.7187H132.704V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82 58.4116H132.703V62.7187H132.82V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.937 58.4116H132.82V62.7187H132.937V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.054 58.4116H132.937V62.7187H133.054V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.171 58.4116H133.054V62.7187H133.171V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.288 58.4116H133.171V62.7187H133.288V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.405 58.4116H133.288V62.7187H133.405V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 58.4116H133.405V62.7187H133.522V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.639 58.4116H133.522V62.7187H133.639V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.756 58.4116H133.639V62.7187H133.756V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.872 58.4116H133.755V62.7187H133.872V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.989 58.4116H133.872V62.7187H133.989V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.106 58.4116H133.989V62.7187H134.106V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.223 58.4116H134.106V62.7187H134.223V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34 58.4116H134.223V62.7187H134.34V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.457 58.4116H134.34V62.7187H134.457V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.574 58.4116H134.457V62.7187H134.574V58.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.691 58.4116H134.574V62.7187H134.691V58.4116Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7Mo);
export default __webpack_public_path__ + "static/media/partner7Mo.216b0cbc844af758b5033685d0975d9d.svg";
export { ForwardRef as ReactComponent };